function getCartKey() {
  try {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    if (user && user[0] && user[0].idClienteGovi) {
      return "cart_" + user[0].idClienteGovi;
    }
  } catch (e) {}
  return "cart";
}

export function getCart() {
  var key = getCartKey();
  var data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}

export function getCartOrEmpty() {
  return getCart() || {};
}

export function setCart(cart) {
  var key = getCartKey();
  localStorage.setItem(key, JSON.stringify(cart));
}

export function clearCart() {
  var key = getCartKey();
  localStorage.removeItem(key);
}

export function getCartItemCount() {
  var cart = getCart();
  return cart ? Object.keys(cart).length : 0;
}
